import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const HealthIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescHealth">cross</desc>
      <circle className="accent" cx="128.7" cy="127.5" r="127.5" />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M127.5 0A127.6 127.6 0 0 0 0 127.5C0 197.8 57.2 255 127.5 255S255 197.8 255 127.5 197.8 0 127.5 0zm82.7 141.6c0 7-5.7 12.8-12.8 12.8h-40.9v41c0 7.1-5.7 12.8-12.8 12.8h-27.6c-7 0-12.7-5.7-12.7-12.8v-41h-41c-7.1 0-12.7-5.7-12.7-12.8v-28.2c0-7.1 5.7-12.8 12.7-12.8h41v-41c0-7 5.7-12.7 12.8-12.7h27.6c7.1 0 12.8 5.7 12.8 12.7v41h40.9c7.1 0 12.8 5.7 12.8 12.8v28.2z"
      />
    </Icon>
  );
};

export default HealthIcon;
